<template>
  <main-layout>
    <div>
      <domain-dialog
        v-model="isDomainDialogOpened"
        :domain="selectedDomain"
        @save="stateSave"
        @close="resetSelectedDomain"/>
      <delete-domain-dialog
        v-model="isDeleteDomainDialogOpened"
        :domain="selectedDomain"
        @delete="stateDelete"
        @close="resetSelectedDomain"/>
      <v-row no-gutters align="center" class="content-header">
        <span class="font-weight-bold">Domaines</span>
        <v-spacer></v-spacer>
        <v-btn dark color="primary" elevation="0" @click="isDomainDialogOpened = true">
          <v-icon left>add</v-icon>
          Nouveau domaine
        </v-btn>
      </v-row>
      <div class="page-main-content">
        <v-simple-table class="pt-5">
          <thead>
            <tr>
              <th class="text-left">Nom</th>
              <th/>
            </tr>
          </thead>
          <tbody>
            <tr v-for="domain in domains" :key="domain.name">
              <td>{{ domain.name }}</td>
              <td class="text-right admin-list-actions">
                <v-btn icon small @click="saveDomain(domain)"><v-icon>edit</v-icon></v-btn>
                <!-- <v-btn icon small>
                  <v-icon color="red" @click="deleteDomain(domain)">delete</v-icon>
                </v-btn> -->
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
    </div>
  </main-layout>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import MainLayout from '@/views/settings/MainLayout.vue';
import DomainDialog from '@/components/Domain/DomainDialog.vue';
import DeleteDomainDialog from '@/components/Domain/DeleteDomainDialog.vue';

export default {
  name: `SettingsDomains`,
  data: () => ({
    isDomainDialogOpened: false,
    isDeleteDomainDialogOpened: false,
    selectedDomain: {},
  }),
  computed: {
    ...mapState(`model/domain`, [
      `makerDomains`,
    ]),
    domains() {
      return _.sortBy(this.makerDomains || [], domain => _.toLower(domain.name));
    },
  },
  methods: {
    saveDomain(domain) {
      this.selectedDomain = domain;
      this.isDomainDialogOpened = true;
    },
    deleteDomain(domain) {
      this.selectedDomain = domain;
      this.isDeleteDomainDialogOpened = true;
    },
    async fetchDomains() {
      await this.$store.dispatch(`model/client/fetchCompany`);
      this.$store.dispatch(`model/domain/fetchMakerDomains`);
    },
    async stateSave() {
      await this.$store.dispatch(`showSnackbar`, {
        color: `success`,
        message: this.selectedDomain && this.selectedDomain.id ? `Domaine modifié avec succès` : `Domaine créé avec succès`,
      });
      this.selectedDomain = {};
    },
    async stateDelete() {
      await this.$store.dispatch(`showSnackbar`, {
        color: `success`,
        message: `Domaine supprimé avec succès`,
      });
      this.selectedDomain = {};
    },
    resetSelectedDomain() {
      this.selectedDomain = {};
    },
  },
  mounted() {
    this.fetchDomains();
  },
  components: {
    MainLayout,
    DomainDialog,
    DeleteDomainDialog,
  },
};
</script>

<style lang="scss">
</style>
